import axios from 'axios'
import { getConfig } from './config'

axios.defaults.xsrfHeaderName = `X-CSRFTOKEN`
axios.defaults.xsrfCookieName = `csrftoken`

const instance = axios.create()

instance.interceptors.request.use(config => {
  if (!config.baseURL) {
    config.baseURL = getConfig(`API_URL`) || ``
  }
  config.headers[`request-startTime`] = Date.now()
  return config
})

instance.interceptors.response.use(response => {
  const start = response.config.headers[`request-startTime`]
  const milliseconds = Date.now() - start
  response.headers[`request-duration`] = milliseconds
  return response
})

export default instance
